export enum BankAccountPermission {
  EDIT = 'edit',
  MANAGE_IMPORT_TYPE = 'manage-import-type',
  MANAGE_EXPORT_TYPE = 'manage_export_type',
};
